module.exports = __webpack_public_path__ + "assets/img/cardItem06.2892f878.png";